export enum WSTopicName {
  OnBuildCompleted = 'OnBuildCompleted',
  OnBuildStarted = 'OnBuildStarted',
  OnTwoFactorAuthProcessCompleted = 'OnTwoFactorAuthProcessCompleted',
  OnQrUsingWithinTwoFactorAuthOperation = 'OnQrUsingWithinTwoFactorAuthOperation'
}
